<template>
  <div class="cardCustom">
    <div class="card cardCustom__side">
      <div class="w-100 h-100">
        <div v-if="loading" class="loadingSection lds-dual-ring"></div>
        <div class="col-5" v-if="$slots.header">
          <slot name="header"></slot>
        </div>
        <div class="col-7" v-if="$slots.content">
          <div v-if="loading" :class="{ bgBlur: true }" :style="blurStyles"></div>
          <slot name="content"></slot>
        </div>
      </div>
      <div v-if="$slots.footer">
        <hr />
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import Card from './Card.vue';
import CardWithSides from '@/components/Cards/CardWithSides';

export default {
  name: 'stats-card',
  components: {
    CardWithSides,
    Card,
  },
  props: {
    chartHeight: String,
    loading: Boolean,
    withDoubleSides: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    blurStyles() {
      return {
        height: `${this.chartHeight}`,
      };
    },
  },
};
</script>
<style></style>
